import { useState } from "react";
import { Link, Outlet, useNavigate } from "react-router-dom";
import axios from "axios";
import { applyLoan} from '../../Services/loanServices';

function LoanApply() {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);

    

    const [fullName, setFullName] = useState("");
    const [mobile, setMobile] = useState("");
    const [email, setEmail] = useState("");
    const [address, setAddress] = useState("");
    const [loanType, setLoanType] = useState("");

    const [aadharPhoto, setAadharPhoto] = useState(null);
    const [panPhoto, setPanPhoto] = useState(null);
    const [customerPhoto, setCustomerPhoto] = useState(null);

    const user = JSON.parse(localStorage.getItem("user"));
    
    
    const handleSubmit = async (e) => {
        e.preventDefault();

        const formData = new FormData();
        formData.append("FullName", fullName);
        formData.append("Mobile", mobile);
        formData.append("Email", email);
        formData.append("Address", address);
        formData.append("LoanType", loanType);

        formData.append("AadhaarFile", aadharPhoto);
        formData.append("PanFile", panPhoto);
        formData.append("PhotoFile", customerPhoto);
        formData.append("CreatedBy", user.id);


          try {
                   await applyLoan(formData);

        // ✅ SUCCESS MESSAGE
        alert("Loan application submitted successfully!");

        // ✅ CLEAR ALL FIELDS
        setFullName("");
        setMobile("");
        setEmail("");
        setAddress("");
        setLoanType("");

        setAadharPhoto(null);
        setPanPhoto(null);
        setCustomerPhoto(null);

        // ✅ RESET FILE INPUT UI
        document.querySelectorAll("input[type='file']").forEach(
            input => input.value = ""
        );
                    
                } catch (error) {
                    console.error("Error adding credit card:", error);
                    alert("Failed to add credit card.");
                }

        
        
    };

    return (
        
        <div>
            
        <div className="wrapper">
            <div className="content-page">
                <div className="content">
                    <div className="container-fluid">

                        {/* PAGE TITLE */}
                        <div className="row">
                            <div className="col-12">
                                <div className="page-title-box">
                                    <div className="page-title-right">
                                        <ol className="breadcrumb m-0">
                                            <li className="breadcrumb-item">
                                                <Link to="/dashboard">Dashboard</Link>
                                            </li>
                                            <li className="breadcrumb-item active">Loan Application</li>
                                        </ol>
                                    </div>
                                    <h4 className="page-title">Loan Application</h4>
                                </div>
                            </div>
                        </div>

                        {/* FORM */}
                        <div className="row">
                            <div className="col-12">
                                <div className="card">
                                    <div className="card-body">
                                        <form onSubmit={handleSubmit} encType="multipart/form-data">

                                            <div className="row g-2">
                                                <div className="mb-3 col-md-4">
                                                    <label className="form-label">Full Name</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        value={fullName}
                                                        onChange={e => setFullName(e.target.value)}
                                                        required
                                                    />
                                                </div>

                                                <div className="mb-3 col-md-4">
                                                    <label className="form-label">Mobile</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        value={mobile}
                                                        onChange={e => setMobile(e.target.value)}
                                                        required
                                                    />
                                                </div>

                                                <div className="mb-3 col-md-4">
                                                    <label className="form-label">Email</label>
                                                    <input
                                                        type="email"
                                                        className="form-control"
                                                        value={email}
                                                        onChange={e => setEmail(e.target.value)}
                                                    />
                                                </div>
                                            </div>

                                            <div className="row g-2">
                                                <div className="mb-3 col-md-8">
                                                    <label className="form-label">Address</label>
                                                    <textarea
                                                        className="form-control"
                                                        rows="2"
                                                        value={address}
                                                        onChange={e => setAddress(e.target.value)}
                                                    />
                                                </div>

                                                <div className="mb-3 col-md-4">
                                                    <label className="form-label">Loan Type</label>
                                                    <select
                                                        className="form-control"
                                                        value={loanType}
                                                        onChange={e => setLoanType(e.target.value)}
                                                        required
                                                    >
                                                        <option value="">Select Loan Type</option>
                                                        <option value="Personal">Personal Loan</option>
                                                        <option value="Home">Home Loan</option>
                                                        <option value="Business">Business Loan</option>
                                                    </select>
                                                </div>
                                            </div>

                                            <div className="row g-2">
                                                <div className="mb-3 col-md-4">
                                                    <label className="form-label">Aadhaar Photo</label>
                                                    <input
                                                        type="file"
                                                        className="form-control"
                                                        onChange={e => setAadharPhoto(e.target.files[0])}
                                                        required
                                                    />
                                                </div>

                                                <div className="mb-3 col-md-4">
                                                    <label className="form-label">PAN Photo</label>
                                                    <input
                                                        type="file"
                                                        className="form-control"
                                                        onChange={e => setPanPhoto(e.target.files[0])}
                                                        required
                                                    />
                                                </div>

                                                <div className="mb-3 col-md-4">
                                                    <label className="form-label">Bank Statement
                                                    </label>
                                                    <input
                                                        type="file"
                                                        className="form-control"
                                                        onChange={e => setCustomerPhoto(e.target.files[0])}
                                                    />
                                                </div>
                                            </div>

                                           <button type="submit" className="btn btn-primary" disabled={loading}>
    {loading ? "Submitting..." : "Submit Loan Application"}
</button>


                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            </div>
            <Outlet />
        </div>
    );
}
export default LoanApply